import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import FadeIn from './FadeIn';
import { weddingFaqs } from '../data/weddingFaqs';

const WeddingFAQ = () => {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section className="py-24 md:py-32 relative px-6 bg-brand-charcoal">
      <div className="max-w-3xl mx-auto relative z-10">
        <FadeIn className="text-center mb-16">
          <span className="text-brand-bronze uppercase tracking-[0.3em] text-[10px] font-semibold mb-4 block">
            Wedding Details
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-brand-vintage font-light">
            Frequently Asked Questions
          </h2>
          <div className="w-16 h-[1px] bg-brand-stone/50 mx-auto mt-6" />
        </FadeIn>
        <div className="space-y-3">
          {weddingFaqs.map((faq, index) => {
            const isOpen = openIdx === index;
            const panelId = `wedding-faq-answer-${index}`;

            return (
              <FadeIn key={faq.q} delay={Math.min(index * 0.025, 0.2)}>
                <div className="border border-brand-vintage/20 bg-white/5 backdrop-blur-sm">
                  <button
                    id={`wedding-faq-question-${index}`}
                    type="button"
                    className="w-full flex justify-between items-center p-5 md:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-bronze"
                    onClick={() => setOpenIdx(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                  >
                    <span className="font-serif text-base md:text-lg text-brand-vintage pr-4">
                      {faq.q}
                    </span>
                    <SafeIcon
                      icon={FiIcons.FiChevronDown}
                      className={`text-brand-bronze shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                    />
                  </button>
                  <div
                    id={panelId}
                    role="region"
                    aria-labelledby={`wedding-faq-question-${index}`}
                    hidden={!isOpen}
                    className="px-5 pb-5 md:px-6 md:pb-6 border-t border-brand-vintage/10"
                  >
                    <p className="pt-4 font-sans text-brand-vintage/80 font-light text-sm leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WeddingFAQ;